export default "__VITE_ASSET__gtNFL9Pd__"